<template>
  <AuthProvider>
    <MasterProvider>
      <GlobalHeader v-if="showHeader" />
      <!-- $route.fullPathだとquery変更だけでも再マウントされてしまうため、
           マッチしたルート自体が変わった時のみ再マウントするようにしている -->
      <router-view :key="$route.matched[0]?.path" />
      <GlobalFooter />
    </MasterProvider>
  </AuthProvider>
</template>

<script setup lang="ts">
import { computed, onBeforeMount } from 'vue';
import { primeSessionFromStorage } from 'src/services/session';
import GlobalHeader from 'src/components/lib/GlobalHeader.vue';
import GlobalFooter from 'src/components/lib/GlobalFooter.vue';
import AuthProvider from 'src/components/lib/AuthProvider.vue';
import MasterProvider from 'src/components/lib/MasterProvider.vue';
import { parseExtParams } from 'src/services/extParams';
import { registerVideojsComponents } from 'src/lib/videojsHelper';
import { providePageType } from 'src/composables/usePageType';
import { provideFullScreenSpinner } from 'src/composables/useFullScreenSpinner';
import { provideEnv } from 'src/composables/useEnv';

provideEnv();
provideFullScreenSpinner();
const { isGuestPage, isPrintPage, isSpPage } = providePageType();

const showHeader = computed(() => !isGuestPage.value && !isPrintPage.value && !isSpPage.value);

// axios のベース URL とトークンは、子の AuthProvider が getMe する前に確実に
// 設定されている必要があるため、setup で同期的に実行する
primeSessionFromStorage();

onBeforeMount(() => {
  parseExtParams();
  registerVideojsComponents();
});
</script>

<style lang="scss">
@use 'src/style/app.scss';
@use 'src/style/tooltip.scss';
#app {
  width: 100%;
  height: 100%;
}
</style>
